import {useCallback, useState} from 'react'
import {ValueType} from "../types";

export function useSelect(initValue?: ValueType) {

    const [value, setValue] = useState(initValue);

    const onChange = useCallback((v: ValueType) => {
        setValue(v);
    }, []);

    const select = {
        onChange, value,
    };

    return [select, setValue] as [typeof select, typeof setValue];
}